export default __webpack_public_path__ + "static/media/tr.0367f2ea.svg";